import { render, staticRenderFns } from "./BidPolicy.vue?vue&type=template&id=5b0d165b&"
import script from "./BidPolicy.vue?vue&type=script&lang=js&"
export * from "./BidPolicy.vue?vue&type=script&lang=js&"
import style0 from "./BidPolicy.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports